import { cancelBookingAction } from "../../actions/booking/cancelBookingAction";

async function submit(values, dispatch) {
    let reason = values?.reason, otherReason = values?.otherReason, bookingId = values?.bookingId;
    reason = reason !== 'other' ? reason : otherReason;
    dispatch(cancelBookingAction({ bookingId, reason }))
}

export default submit;